var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSiderMenuArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 5 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.703 3.026L.801.33A.44.44 0 00.31.321a.524.524 0 00-.182.204.615.615 0 00-.067.28v5.39c0 .099.023.195.067.28a.524.524 0 00.181.204.44.44 0 00.491-.01l3.902-2.695a.529.529 0 00.172-.202.616.616 0 000-.544.529.529 0 00-.172-.202z"
  })));
}

export default SvgSiderMenuArrow;